import React, { createContext, useReducer } from 'react';
import { PropTypes } from 'prop-types';

const initialState = {
    variant: 'main',
    theme: {
        colors: {
            accent: '#0062E6',
            background: '#eef1f3',
            dark: '#172c36',
            foreground: '#ffffff',
            inactive: '#c1c1c1',
            primary: '#eb9343',
        },
        typography: {
            anchor: '#343a40',
            anchorHover: '#484d53',
            footer: '#666666',
            light: '#fafafa',
            text: '#171818',
        },
    },
    kiosk: {},
    columnSettings: {},
    helpLink: {
        enable: false,
        url: "",
        tooltip: ""
    }
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_DEFAULT_COLUMN_SETTINGS':
            return { ...state, columnSettings: { ...action.columnSettings } };
        case 'SET_THEME':
            return { ...state, theme: { ...state.theme, ...action.theme } };
        case 'SET_HELPLINK':
            return { ...state, helpLink: { ...state.helpLink, ...action.helpLink } };
        case 'SET_KIOSK_MODE':
            return { ...state, kiosk: { ...action.payload } };
        default:
            return { ...state };
    }
};

export const BrandingStateContext = createContext();
export const BrandingDispatchContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <BrandingStateContext.Provider value={state}>
            <BrandingDispatchContext.Provider value={dispatch}>
                {children}
            </BrandingDispatchContext.Provider>
        </BrandingStateContext.Provider>
    );
};

BrandingProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
